// extracted by mini-css-extract-plugin
export default {"progress__container":"ProgressBar_progress__container__XhS+c","progress__bar":"ProgressBar_progress__bar__983FB","progress__label":"ProgressBar_progress__label__02xpk"};